import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useArticles from '../../../Data/Article/useArticles';
import LazyImage from '../../../components/lazy/Image';
import Link from '../../../components/link';
import { useDelayedRender } from '../../../hooks/renderers';
import { getMarket } from '../../../i18n';
import { ContentEvents } from '../../../shared/tracking';
import { IconPlay } from '../../../styled-components/components/Icon';
import { createArticleUrl } from '../../articles/utils';
import { getLatestTestDriveArticleURLSearchParams } from './utils';

interface TestDriveLatestArticleProps {
  track: (event: string, data: any) => void;
}

const TestDriveLatestArticle = ({ track }: TestDriveLatestArticleProps) => {
  const { t } = useTranslation('startpage');

  const marketCode = getMarket()?.marketCode;
  const [result] = useArticles(getLatestTestDriveArticleURLSearchParams(marketCode));
  const article = result?.response.documentList.documents?.[0];

  const [reference, setReference] = useState<HTMLDivElement | null>(null);

  useDelayedRender(() => {
    if (article) {
      track(ContentEvents.NEWS_ITEM_EXPOSURE, {
        newsItemId: article.id,
        newsItemName: article.title,
      });
    }
  }, reference);

  const onClick = () => {
    if (article) {
      track(ContentEvents.NEWS_ITEM_VIEW, {
        newsItemId: article.id,
        newsItemName: article.title,
      });
    }
  };

  const src = article?.featuredMedia?.file?.url
    ? `url(${article.featuredMedia.file.url}?w=${1240}`
    : undefined;

  if (!article) return null;
  const url = createArticleUrl(article.categories, article.slug);

  return (
    <section className="page-section">
      <Link to={url} title={t('Show all test drives', { ns: 'startpage' }) || ''}>
        <div
          data-wx-articlecard="video"
          onClick={onClick}
          title={t('Read the article', { ns: 'startpage', name: article?.title }) || ''}
          ref={setReference}
        >
          <LazyImage className="article-card-image" src={src} />
          <div className="article-card-action">
            {article.videoUrl && (
              <div data-wx-actionbutton="action huge">
                <IconPlay />
              </div>
            )}
          </div>
          <div className="article-card-body">
            <div data-wx-label="light" className="article-card-pre-heading">
              {t('Latest test drive on Wayke', { ns: 'startpage' })}
            </div>
            <div className="article-card-heading">{article?.title}</div>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default TestDriveLatestArticle;
